import { render, staticRenderFns } from "./LayoutNavigationLink.vue?vue&type=template&id=6df5c315&"
import script from "./LayoutNavigationLink.vue?vue&type=script&lang=js&"
export * from "./LayoutNavigationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df5c315')) {
      api.createRecord('6df5c315', component.options)
    } else {
      api.reload('6df5c315', component.options)
    }
    module.hot.accept("./LayoutNavigationLink.vue?vue&type=template&id=6df5c315&", function () {
      api.rerender('6df5c315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutNavigationLink.vue"
export default component.exports